import { render, staticRenderFns } from "./DoughnutChartContainer.vue?vue&type=template&id=36283d6c&"
import script from "./DoughnutChartContainer.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports